"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASF_SET_Fields_Encoding = exports.GeneralDownlinkPayloadAttributeRangeLimits = exports.DeviceConfigTypeFields = void 0;
const EncodingTypes_1 = require("./EncodingTypes");
exports.DeviceConfigTypeFields = {
    ADR: EncodingTypes_1.EncodingType.U8Int,
    DR: EncodingTypes_1.EncodingType.U8Int,
    Activity: EncodingTypes_1.EncodingType.U16IntLE,
    Condition: EncodingTypes_1.EncodingType.U16IntLE,
    Alert: EncodingTypes_1.EncodingType.U16IntLE,
};
exports.GeneralDownlinkPayloadAttributeRangeLimits = {
    adr: { attributeType: 'number', range: { min: 0, max: 1 } },
    appCycleTime: { attributeType: 'number', range: { min: 1, max: 1440 } },
    dr: { attributeType: 'number', range: { min: 0, max: 2 } },
    sysCycleTime: { attributeType: 'number', range: { min: 60, max: 10800 } },
    sendConfig: {
        attributeType: 'number',
        range: {
            min: 0,
            max: 0,
        },
    },
    accelerometerThreshold: {
        attributeType: 'number',
        range: {
            min: 0,
            max: 0,
        },
    },
    clearErrorCodes: {
        attributeType: 'number',
        range: {
            min: 0,
            max: 0,
        },
    },
    restoreDefaults: {
        attributeType: 'number',
        range: {
            min: 0,
            max: 0,
        },
    },
    reboot: {
        attributeType: 'number',
        range: {
            min: 0,
            max: 0,
        },
    },
    downlinkDeviceShutdown: {
        attributeType: 'boolean',
    },
    downlinkRandom: {
        attributeType: 'boolean',
    },
    downlinkReboot: {
        attributeType: 'boolean',
    },
    downlinkReqOptions: {
        attributeType: 'boolean',
    },
    downlinkRestore: {
        attributeType: 'boolean',
    },
    downlinkSetOptions: {
        attributeType: 'boolean',
    },
    optionsValues: {
        attributeType: 'array',
    },
};
exports.ASF_SET_Fields_Encoding = {
    enableDisable: EncodingTypes_1.EncodingType.U8Int,
    ULrDL: EncodingTypes_1.EncodingType.U8Int,
    DMissL: EncodingTypes_1.EncodingType.U8Int,
    MaxSF: EncodingTypes_1.EncodingType.U8Int
};
